module.exports = __webpack_public_path__ + "static/media/attend_event_important.43bd8ef8.svg";